import { render, staticRenderFns } from "./requestsPerMonthsChart.vue?vue&type=template&id=352e3d65&scoped=true"
import script from "./requestsPerMonthsChart.vue?vue&type=script&lang=js"
export * from "./requestsPerMonthsChart.vue?vue&type=script&lang=js"
import style0 from "./requestsPerMonthsChart.vue?vue&type=style&index=0&id=352e3d65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352e3d65",
  null
  
)

export default component.exports